import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';
import { getStorage } from 'firebase/storage';
import { getFunctions } from 'firebase/functions';

// Ops project (this app's primary backend)
const opsConfig = {
  apiKey: "AIzaSyD5y2ObgftvW5srYl9IJgYxpr_gz6BRl8g",
  authDomain: "agriware-operations-2d9a7.firebaseapp.com",
  projectId: "agriware-operations-2d9a7",
  storageBucket: "agriware-operations-2d9a7.firebasestorage.app",
  messagingSenderId: "489916500824",
  appId: "1:489916500824:web:3dcbf9d0d48b15be3c732d"
};

const opsApp = initializeApp(opsConfig);

export const auth = getAuth(opsApp);
export const db = getFirestore(opsApp);
export const storage = getStorage(opsApp);
export const functions = getFunctions(opsApp, 'europe-west2');

// HQ project (for library reads via Cloud Functions)
// We initialise a second Firebase app pointing at HQ, but only use it
// for callable functions (NOT auth, db, or storage — those stay on the Ops project).
const hqConfig = {
  apiKey: "AIzaSyDM9LfaAvcguPThVSl9LhRbYiBtse0O5zo",
  authDomain: "agriware-hq.firebaseapp.com",
  projectId: "agriware-hq",
  storageBucket: "agriware-hq.firebasestorage.app",
  messagingSenderId: "590642472140",
  appId: "1:590642472140:web:5fe8886b59c90106248e69"
};

const hqApp = initializeApp(hqConfig, 'hq');
export const hqFunctions = getFunctions(hqApp, 'europe-west2');

export default opsApp;
